export const allEstimatedProjectValueBands = [
  'under-10k',
  '10k-25k',
  '25k-50k',
  '50k-100k',
  '100k-250k',
  '250k-500k',
  '500k-1m',
  '1m-plus',
] as const

export type EstimatedProjectValueBand = (typeof allEstimatedProjectValueBands)[number]
